// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table_tableWrapper__t6aUZ","loadingOverlay":"Table_loadingOverlay__qxxmN","clickableRow":"Table_clickableRow__nuf6v"};